import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekBox = styled(Box)(({ theme }) => ({}));

export { PeekBox, PeekBox as default };
